.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}

.uploadSection {
  display: flex;
}

.uploadTrigger {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tooltipText {
  font-size: 12px;
  line-height: 1.6;
}

.uploadIcon {
  &:hover {
    svg {
      fill: rgba(234, 27, 10, 0.76);
    }
  }

  &--active {
    svg {
      fill: #ea1b0a;
    }
  }
}

.filesContainer {
  display: flex;
  flex-direction: column;
  gap: 4px;


  &__preview {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 4px;
    background-color: #f0f0f0;
  }

  p {
    font-size: 14px;
    color: #444;
    margin: 0;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.uploadWrapper {
  display: flex;
  align-items: center;
}


.uploadIcon,
.uploadIcon--active {
  cursor: pointer;
  align-items: center;
}